import { hasAccessRestriction } from "../../components/map/mapEdDisplay";
import {
  CAPABILITY_VERIFICATION_ELIGIBLE_STATUSES,
} from "../../constants/diagnosticCapabilities";
import {
  isEmergencyDepartment,
  isUrgentCare,
} from "../../constants/facilityTypes";

/**
 * Default ranking eligibility (verification status / ED type).
 *
 * @param {object | null | undefined} locationDoc
 * @returns {boolean}
 */
export function isLocationEligibleForDefaultRanking(locationDoc) {
  if (isEmergencyDepartment(locationDoc)) {
    return true;
  }
  if (isUrgentCare(locationDoc)) {
    return true;
  }
  const status = locationDoc?.capabilityVerification?.status;
  if (!status) {
    return false;
  }
  return CAPABILITY_VERIFICATION_ELIGIBLE_STATUSES.includes(status);
}

/**
 * Normalize patient age for matching gates.
 *
 * @param {number | string | null | undefined} patientAge
 * @returns {{ numericAge: number | null, isUnknown: boolean }}
 */
export function normalizePatientAge(patientAge) {
  if (patientAge === "unknown" || patientAge == null || patientAge === "") {
    return { numericAge: null, isUnknown: true };
  }
  const numericAge = Number(patientAge);
  if (Number.isFinite(numericAge) && numericAge >= 0 && numericAge <= 120) {
    return { numericAge, isUnknown: false };
  }
  return { numericAge: null, isUnknown: true };
}

/**
 * Whether a location may appear in SCMap / CareMap diagnostic matching.
 * Restricted federal EDs are never matched; pediatric-only EDs exclude adults (≥18).
 *
 * @param {object | null | undefined} locationDoc
 * @param {{ numericAge?: number | null, isUnknown?: boolean }} [ageContext]
 * @returns {boolean}
 */
export function isLocationEligibleForMatching(locationDoc, ageContext = {}) {
  if (!isLocationEligibleForDefaultRanking(locationDoc)) {
    return false;
  }
  if (hasAccessRestriction(locationDoc)) {
    return false;
  }
  const { numericAge = null } = ageContext;
  if (locationDoc?.pediatricOnly && numericAge != null && numericAge >= 18) {
    return false;
  }
  return true;
}
